import FacebookIcon from 'assets/svg/socials/icon-fb.svg';
import HyperLinkIcon from 'assets/svg/socials/icon-hyperlink.svg';
import LinkedInIcon from 'assets/svg/socials/icon-linkedin.svg';
import MailIcon from 'assets/svg/socials/icon-mail.svg';
import TwitterIcon from 'assets/svg/socials/icon-twitter.svg';
import React from 'react';
import { toast } from 'react-hot-toast';

import { DLink } from '@dnse/ui';

import { NextImage, nextImageLoader } from './NextImage';


interface ShareProps {
  title: string;
  href: string;
  postUrl?: string;
}

export const FloatShare: React.FunctionComponent<ShareProps> = ({
                                                                  title,
                                                                  href,
                                                                  postUrl
                                                                }) => {

  const copyToClipBoard = async () => {
    try {
      await navigator.clipboard.writeText(postUrl || '');
      toast.custom(
        <div className="flex gap-2 px-3 py-4 w-[250px] rounded text-gray-300 bg-[#E7F9EC]">
          <img
            src="/images/svg/check-circle-fill.svg"
            alt="Shape Icon Mobile"
            role="presentation"
            // @ts-expect-error Ignore type checking
            fetchpriority="low"
            importance="low"
            decoding="async"
            loading="eager"
            width={24}
            height={24}
          />
          <div className="-pt-1">
            <p className="text-base font-medium">Thành công!</p>
            <p className="text-xs">Đã sao chép đường dẫn</p>
          </div>
        </div>,
        {position: 'top-right', duration: 3000}
      );
    } catch {
      toast.custom(
        <div className="flex gap-2 px-3 py-4 w-[250px] rounded text-gray-300 bg-[#FCE6E6]">
          <img
            src="/images/svg/all.svg#error-circle-outline"
            alt="Shape Icon Mobile"
            role="presentation"
            // @ts-expect-error Ignore type checking
            fetchpriority="low"
            importance="low"
            decoding="async"
            loading="lazy"
            width={24}
            height={24}
          />
          <div className="-pt-1">
            <p className="text-base font-medium">Có lỗi xảy ra!</p>
            <p className="text-xs">Vui lòng thử lại</p>
          </div>
        </div>,
        {position: 'top-right', duration: 3000}
      );
    }
  };

  return (
    <div className="flex md:flex-col gap-4 items-center">
      <div>
        <button
          onClick={() => {
            window.open(
              `https://www.facebook.com/sharer/sharer.php?u=${postUrl}`,
              'facebook-share',
              'width=580, height=296'
            );
            return false;
          }}
        >
          <div className="w-[30px] h-[30px]">
            <NextImage
              loader={nextImageLoader}
              src={FacebookIcon.src}
              alt="share facebook"
              width={30}
              height={30}
              layout="fixed"
              priority={false}
            />
          </div>
        </button>
      </div>
      <div>
        <button
          onClick={() => {
            window.open(
              `https://twitter.com/share?text=${title}&url=${postUrl}`,
              'twitter-share',
              'width=550, height=235'
            );
            return false;
          }}
        >
          <div className="w-[30px] h-[30px]">
            <NextImage
              loader={nextImageLoader}
              src={TwitterIcon.src}
              alt="share facebook"
              width={30}
              height={30}
              layout="fixed"
              priority={false}
            />
          </div>
        </button>
      </div>
      <div>
        <button
          onClick={() => {
            window.open(
              `https://www.linkedin.com/shareArticle?mini=true&url=${postUrl}&title=${title}`,
              'linkedin-share',
              'width=580, height=296'
            );
            return false;
          }}
        >
          <div className="w-[30px] h-[30px]">
            <NextImage
              loader={nextImageLoader}
              src={LinkedInIcon.src}
              alt="share facebook"
              width={30}
              height={30}
              layout="fixed"
              priority={false}
            />
          </div>
        </button>
      </div>
      <div>
        <DLink
          href={`mailto:?subject=${title}&body=${postUrl}`}
          target="_blank"
        >
          <div className="w-[30px] h-[30px]">
            <NextImage
              loader={nextImageLoader}
              src={MailIcon.src}
              alt="share facebook"
              width={30}
              height={30}
              layout="fixed"
              priority={false}
            />
          </div>
        </DLink>
      </div>
      <div>
        <button onClick={copyToClipBoard} className="w-[30px] h-[30px]">
          <NextImage
            loader={nextImageLoader}
            src={HyperLinkIcon.src}
            alt="share facebook"
            width={30}
            height={30}
            layout="fixed"
            priority={false}
          />
        </button>
      </div>
    </div>
  );
};
